import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L13 13M13 1L1 13", stroke: "#F0F0F0", strokeWidth: 1.125, strokeLinecap: "round" }));
export default SvgClose;
